import axios from 'axios'
import qs from 'qs'
import mapApiUrl from '@/src/utils/api-mapper'

export const state = {
  cached: [],
  userList: [],
  roleList: []
}

export const getters = {
  userList(state) {
    return state.userList
  },
  roleList(state) {
    return state.roleList
  },
}

export const mutations = {
  CACHE_USER(state, newUser) {
    state.cached.push(newUser)
  },
  SET_USER_LIST(state, newValue) {
    state.userList = newValue
  },
  SET_ROLE_LIST(state, newValue) {
    state.roleList = newValue
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    // setDefaultAuthHeaders(state)
  },
  setUserList({ commit }, list) {
    commit('SET_USER_LIST', list)
  },
  setRoleList({ commit }, list) {
    commit('SET_ROLE_LIST', list)
  },
  fetchUser({ commit, state, rootState }, { username }) {
    // 1. Check if we already have the user as a current user.
    const { currentUser } = rootState.auth
    if (currentUser && currentUser.username === username) {
      return Promise.resolve(currentUser)
    }

    // 2. Check if we've already fetched and cached the user.
    const matchedUser = state.cached.find((user) => user.username === username)
    if (matchedUser) {
      return Promise.resolve(currentUser)
    }

    // 3. Fetch the user from the API and cache it in case
    //    we need it again in the future.
    return axios.get(mapApiUrl(`/api/users/${username}`)).then((response) => {
      const user = response.data
      commit('CACHE_USER', user)
      return user
    })
  },

  getUserList({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/identity/user/list');
    return axios
      .get(url, { params: params })
      .then((response) => {
        if (response) {
          const list = response.data.data
          dispatch('setUserList', list.content)
          return response
        }
      })
      .catch(err => {
        console.log(err)
        dispatch('setUserList', [])
      })
  },

  addUser({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/identity/user/add')
    return axios
      .post(url, qs.stringify(params))
      .then((response) => {
        return response
      })
  },

  updateUser({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/identity/user/update')
    return axios
    .post(url, qs.stringify(params))
      .then((response) => {
        return response
      })
  },

  deleteUser({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/identity/user/remove')
    return axios
    .delete(url, { params: params })
      .then((response) => {
        return response
      })
  },

  getRoleList({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/identity/role/list');
    return axios
      .get(url, { params: params })
      .then((response) => {
        const list = response.data.data
        dispatch('setRoleList', list)
        return response
      })
      .catch(err => {
        console.log(err)
        dispatch('setRoleList', [])
      })
  },

  changeAvatar({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/identity/user/change_avatar')
    const data = new FormData()
    data.append('avatar', params.avatar)
    return axios
      .post(url, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((response) => {
        return response
      })
  },

  changePassword({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/identity/user/change_password')
    return axios
    .post(url, qs.stringify(params))
      .then((response) => {
        return response
      })
  },
}
